import React, { useState } from "react";
import { TextField, Button, Stack } from "@mui/material";

import { default_country_code } from 'config'

const PhoneNumberForm = (props) => {
  const { handleForm, isLoading } = props;
  // const [phoneNumber, setPhoneNumber] = useState("11111111");
  // const [phoneNumber, setPhoneNumber] = useState("55555555");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState(default_country_code);

  function onSubmit(event) {
    event.preventDefault();

    handleForm(`${countryCode} ${phoneNumber}`);
  }


  return <>
    <form onSubmit={onSubmit}>
      <Stack spacing={2} direction="row">
        <TextField 
          label="Country Code"
          onChange={e => setCountryCode(e.target.value)}
          required
          variant="outlined"
          color="secondary"
          type="text"
          sx={{width: 110}}
          value={countryCode}
         />
        <TextField 
          label="Phone Number"
          onChange={e => setPhoneNumber(e.target.value)}
          required
          variant="outlined"
          color="secondary"
          type="phone"
          value={phoneNumber}
         />
        </Stack>
        <div id="recaptcha-container" />
       <Button
         variant="contained"
         disabled={isLoading}
         color="secondary"
         type="submit"
         fullWidth
         sx={{ mt: 3, mb: 2 }}
        >
          Continue
        </Button>
    </form>
  </>
}

export default PhoneNumberForm;
